import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './ui/button';
import { Globe } from 'lucide-react';

const LanguageSelector = ({ variant = "ghost" }) => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <Button
      variant={variant}
      size="sm"
      onClick={toggleLanguage}
      className="flex items-center space-x-2"
      data-testid="language-selector"
    >
      <Globe className="h-4 w-4" />
      <span className="font-semibold uppercase">{language}</span>
    </Button>
  );
};

export default LanguageSelector;
